import {FC} from 'react';
import {Category} from '@/apiTypes/event';
import {Typography} from '@/components/ui/typography';
import {groupCategories} from '../eventRoutes';
import {CategoryItem} from './categoryItem';
import {EventSection} from '@/components/eventPage/eventSection';

interface CategoriesProps {
  categories?: Category[];
}

export const Categories: FC<CategoriesProps> = ({categories}) => {
  if (!categories || categories?.length <= 1) return null;

  const groupedCategories = groupCategories(categories);

  return (
    <EventSection
      label="Categories"
      adornment={
        <div className="flex-1 text-right">
          <Typography level="B3" className="text-neutral-500">
            {categories.length}{' '}
            {categories.length === 1 ? 'category' : 'categories'} available
          </Typography>
        </div>
      }
    >
      <div className="flex flex-col gap-6">
        {groupedCategories.map((group) => (
          <div key={group.groupName || 'ungrouped'} className="flex flex-col">
            <div className="">
              {group.groupName && (
                <Typography level="H5" className="font-semibold">
                  {group.groupName}
                </Typography>
              )}
            </div>
            <div className="flex flex-col gap-6">
              {group.categories.map((category, index) => (
                <>
                  <CategoryItem key={category.id} category={category} />
                  {index < group.categories.length - 1 && <hr />}
                </>
              ))}
            </div>
          </div>
        ))}
      </div>
    </EventSection>
  );
};
